import { rgba } from 'polished';
import styled from 'styled-components';

import { c00EE91, c56EA99, cEA135E, cFF005C, cFFFFFF } from '#/colors';

export const Mono = styled.pre`
  display: inline-block;
  margin: 0;
`;

export const ValueChange = styled.span<{ direction: 'up' | 'down' }>`
  color: ${({ direction }) => (direction === 'down' ? cEA135E : c56EA99)};
`;

export const SideBase = styled.span`
  border-radius: 3px;
  display: inline-grid;
  place-items: center;
  font-size: 10px;
  padding: 0 6px;
  height: 18px;
  font-weight: bold;
`;

export const SideBuy = styled(SideBase).attrs({ children: 'BUY' })`
  width: 38px;
  color: ${c00EE91};
  background: ${rgba(c00EE91, 0.2)};
`;

export const SideSell = styled(SideBase).attrs({ children: 'SELL' })`
  width: 38px;
  color: ${cFF005C};
  background: ${rgba(cFF005C, 0.2)};
`;

export const Centered = styled.div`
  display: grid;
  place-items: center;
  height: 100%;
`;

export const Empty = styled(Centered)`
  color: ${rgba(cFFFFFF, 0.4)};
  font-size: 12px;
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const Error = styled(Centered)`
  color: ${rgba(cEA135E, 0.7)};
`;

interface ValuePairProps {
  readonly primary: string;
  readonly secondary: string;
}

export function ValuePair(props: ValuePairProps) {
  return (
    <span css="font-size: 11px;">
      <span>{props.primary}</span>
      <br />
      <span css="opacity: 0.7">{props.secondary}</span>
    </span>
  );
}
